import { TreatmentHistoryDetailProvider } from '@context/TreatmentHistoryDetail';

import TreatmentHistoryDetailView from './TreatmentHistoryDetailView';

const TreatmentHistoryDetail = () => {
  return (
    <TreatmentHistoryDetailProvider>
      <TreatmentHistoryDetailView />
    </TreatmentHistoryDetailProvider>
  );
};

export default TreatmentHistoryDetail;
